<template>
  <div class="flex justify-end items-center pad">
    <vs-dropdown v-if="params.data.receipt_detail">
      <span class="dot"></span>
      <vs-dropdown-menu>
        <vs-dropdown-item>
          <div class="w-max">
            <div class="grid grid-cols-4 gap-x-3 gap-y-2 py-2 header-text">
              <div class="col-span-3"><p>เรียกเก็บแล้ว</p></div>
              <div class="col-span-1 text-right">
                <p>
                  {{
                    numberComma(params.data.receipt_detail.amount.toFixed(2))
                  }}
                </p>
              </div>
              <div class="col-span-3"><p>ยังไม่ได้เรียกเก็บ</p></div>
              <div class="col-span-1 text-right">
                <p>
                  {{
                    numberComma(
                      (
                        params.data.net - params.data.receipt_detail.amount
                      ).toFixed(2)
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="grid grid-cols-4 gap-x-3 gap-y-2 py-2">
              <div class="col-span-4">
                <u class="font-bold">เอกสารที่เกี่ยวข้อง</u>
              </div>
              <div class="col-span-4">
                <ul>
                  <li
                    v-for="(receipt, index) in params.data.receipt_detail
                      .receipt"
                    :key="index"
                  >
                    {{ receipt }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <p>
      {{ numberComma(params.value.toFixed(2)) }}
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params.data);
  },
  methods: {
    numberComma(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: circle;
  list-style-position: inside;
}

.dot {
  margin-right: 10px;
  height: 12px;
  width: 12px;
  background-color: #ffdfbe;
  border-radius: 50%;
  display: inline-block;
}

.header-text {
  border-bottom: solid 0.5px #8d9498;
}

.pad{
padding-right: 10%;
}
</style>
